import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsRoadmapRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-roadmap',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
	exact: true,
};
